import fail from '../../../assets/images/failIcon.svg';
import { closePopup } from '../../../store/slices/popupSlice';
import { useAppDispatch, useAppSelector } from '../../../store/store';
import GreyButton from '../../ui/buttons/greyButton/GreyButton';
import RedButton from '../../ui/buttons/redButton/RedButton';
import styles from './styles/styles.module.css';

function ErrorPopup() {
  const dispatch = useAppDispatch();
  const popupProps = useAppSelector((state) => state.popup.popupProps);
  const errorTitle = popupProps?.errorTitle || '';
  const errorText = popupProps?.errorText || '';
  const buttonText = popupProps?.buttonText || '';
  const errorParagraph = popupProps?.errorParagraph || '';
  const onBack = popupProps?.onBackButton || '';

  const handleClosePopup = () => {
    dispatch(closePopup());
  };

  return (
    <div className={styles.errorPopupWrapper}>
      <button
        className={styles.closePopupButton}
        onClick={handleClosePopup}
        aria-label="Закрыть"
      />
      <div className={styles.errorTextWrapper}>
        <img src={fail} alt="иконка красный крестик" />
        <h2 className={styles.errorTitle}>{errorTitle}</h2>
        <h3 className={styles.errorSubTitle}>{errorText}</h3>
        <span className={styles.errorParagraph}>{errorParagraph}</span>
      </div>
      <div className={onBack ? styles.buttonsWrapper : ''}>
        {onBack ? (
          <GreyButton
            text="Назад"
            onClick={() => {
              handleClosePopup();
            }}
            height={50}
          />
        ) : (
          ''
        )}
        <RedButton
          text={buttonText}
          onClick={handleClosePopup}
          height={50}
          width={onBack ? null : 308}
        />
      </div>
    </div>
  );
}

export default ErrorPopup;
